<template>
    <form @submit.prevent="proceed" @keydown="postForm.errors.clear($event.target.name)">
        <div class="form-group">
            <label>{{ trans('blog.title') }}</label>
            <input class="form-control" type="text" v-model="postForm.title" name="title" :placeholder="trans('blog.title')">
            <show-error :form-name="postForm" prop-name="title"></show-error>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 form-group">
                <label>{{ trans('blog.slug') }}</label>
                <input class="form-control" type="text" v-model="postForm.slug" name="slug" placeholder="auto-from-title">
                <show-error :form-name="postForm" prop-name="slug"></show-error>
            </div>
            <div class="col-12 col-md-6 form-group">
                <label>{{ trans('blog.category') }}</label>
                <input class="form-control" type="text" v-model="postForm.category" name="category" :placeholder="trans('blog.category')">
                <show-error :form-name="postForm" prop-name="category"></show-error>
            </div>
        </div>
        <div class="form-group">
            <label>{{ trans('blog.excerpt') }}</label>
            <textarea class="form-control" rows="3" v-model="postForm.excerpt" name="excerpt" :placeholder="trans('blog.excerpt')"></textarea>
            <show-error :form-name="postForm" prop-name="excerpt"></show-error>
        </div>
        <div class="form-group">
            <label>{{ trans('blog.body') }}</label>
            <html-editor name="body" :model.sync="postForm.body" :isUpdate="!!id" @clearErrors="postForm.errors.clear('body')"></html-editor>
            <show-error :form-name="postForm" prop-name="body"></show-error>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 form-group">
                <label>{{ trans('blog.status') }}</label>
                <select class="form-control" v-model="postForm.status" name="status">
                    <option value="draft">{{ trans('blog.draft') }}</option>
                    <option value="published">{{ trans('blog.published') }}</option>
                </select>
                <show-error :form-name="postForm" prop-name="status"></show-error>
            </div>
            <div class="col-12 col-md-6 form-group">
                <label>{{ trans('blog.published_at') }}</label>
                <input class="form-control" type="datetime-local" v-model="postForm.published_at" name="published_at">
                <show-error :form-name="postForm" prop-name="published_at"></show-error>
            </div>
        </div>
        <div class="admin-plan-form__actions">
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <admin-icon name="check"></admin-icon>
                <span v-if="id">{{ trans('general.update') }}</span>
                <span v-else>{{ trans('general.save') }}</span>
            </button>
            <router-link v-show="id" to="/blog" class="btn btn-sm admin-form-btn-cancel">{{ trans('general.cancel') }}</router-link>
        </div>
    </form>
</template>
<script>
    import htmlEditor from '../../components/html-editor'

    export default {
        components: { htmlEditor },
        props: ['id'],
        data() {
            return {
                postForm: new Form({
                    title: '',
                    slug: '',
                    category: '',
                    excerpt: '',
                    body: '',
                    status: 'draft',
                    published_at: ''
                })
            };
        },
        mounted() {
            if (this.id) {
                this.getPost();
            }
        },
        methods: {
            proceed() {
                if (this.id) {
                    this.updatePost();
                } else {
                    this.storePost();
                }
            },
            storePost() {
                this.postForm.post('/api/blog')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed');
                    })
                    .catch(error => helper.showErrorMsg(error));
            },
            getPost() {
                axios.get('/api/blog/' + this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.postForm.title = response.title;
                        this.postForm.slug = response.slug;
                        this.postForm.category = response.category || '';
                        this.postForm.excerpt = response.excerpt;
                        this.postForm.body = response.body;
                        this.postForm.status = response.status;
                        this.postForm.published_at = this.toLocalInput(response.published_at);
                    })
                    .catch(() => this.$router.push('/blog'));
            },
            updatePost() {
                this.postForm.patch('/api/blog/' + this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/blog');
                    })
                    .catch(error => helper.showErrorMsg(error));
            },
            toLocalInput(value) {
                if (!value) return '';
                let date = new Date(value);
                if (isNaN(date.getTime())) return '';
                let pad = n => (n < 10 ? '0' + n : n);
                return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes());
            }
        }
    }
</script>
